import useSWR from "swr";
import { IPlanInfo } from "../store/interfaces";
import { shortenDate } from "../utils/date";
import { getStateAbbreviation } from "../utils/stateAbbreviations";
import axiosSingleton from "../api/axios";

export function useEffectiveDates(planInfo: IPlanInfo | undefined) {
    const stateAbbreviation = planInfo?.planState ? getStateAbbreviation(planInfo.planState) : 'NY';
    const currentDate = planInfo?.currentDate ? shortenDate(planInfo.currentDate) : new Date().toISOString().split('T')[0];
    const periodType = planInfo?.enrollmentPeriodType || 'se';
    // Fetch effective dates based on state abbreviation and enrollment period type
    const url = `EffectiveDates?stateAbbreviation=${stateAbbreviation}&periodType=${periodType}&date=${currentDate}`;

    const { isLoading, data: effectiveDates, error } = useSWR(url, {
        fetcher: async (url: string) => {
            const res = await axiosSingleton.get(url);
            if (res.status !== 200) {
                // This will set SWR's error object
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.data;
        },
        errorRetryCount: 1,
        dedupingInterval: 3600000, // 1 hour deduplication - cache effective dates for 1 hour
    });
    return { effectiveDates, isLoading, error };
}